import React, { useState, useEffect, useRef } from "react";
import "../Admin/table.css";
import { toast, ToastContainer } from "react-toastify";
import { message } from "antd";
import { Form, Select, Input, DatePicker, TimePicker, Button } from "antd";
import moment from "moment";
import { Row, Col } from "antd";
import Multiselect from "multiselect-react-dropdown";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import loader from "../../Images/ajax-loader.gif";
import { Tooltip } from "antd";

import {
  getDistrict,
  show_resource_detail,
  getBlockByDistrict,
  getVillageByBlock,
  schedule_meeting_api,
  ward_sabha_check,
} from "../../api/User";
import { getVoterCount, updateVoterCount } from "../../api/User";
// Custom DatePicker component that opens calendar when clicking calendar icon
const CustomDatePicker = ({ value, onChange, disabledDate, format = "YYYY-MM-DD", status, placeholder, ...props }) => {
  const [open, setOpen] = useState(false);
  const suffixRef = useRef(null);

  const handleInputClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(false);
  };

  const handleCalendarIconClick = (e) => {
    e.stopPropagation();
    setOpen(!open);
  };

  const handleClear = () => {
    // Clear the date
    if (onChange) {
      onChange(null);
    }
  };

  const handlePanelChange = (date) => {
    if (onChange) {
      onChange(date);
    }
    setOpen(false);
  };

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <DatePicker
        value={value}
        onChange={handlePanelChange}
        disabledDate={disabledDate}
        format={format}
        open={open}
        onOpenChange={setOpen}
        style={{ width: "100%", height: "40px", paddingRight: "35px" }}
        className="dark-placeholder"
        status={status}
        placeholder={placeholder}
        {...props}
        suffixIcon={null}
        onClick={handleInputClick}
        getPopupContainer={(trigger) => trigger.parentNode}
      />
      {/* Custom calendar icon */}
      <span
        ref={suffixRef}
        onClick={handleCalendarIconClick}
        style={{
          position: 'absolute',
          right: '12px',
          top: '50%',
          transform: 'translateY(-50%)',
          cursor: 'pointer',
          fontSize: '16px',
          color: '#00000073',
          zIndex: 2
        }}
        title="Open calendar"
      >
        📅
      </span>
      {/* Clear icon when date is selected */}
      {value && (
        <span
          onClick={handleClear}
          style={{
            position: 'absolute',
            right: '35px',
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#00000073',
            zIndex: 2,
            width: '20px',
            height: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f5f5f5',
            borderRadius: '50%'
          }}
          title="Clear date"
        >
          ×
        </span>
      )}
    </div>
  );
};
const GramSabhaMeeting = ({ }) => {
  const { Option } = Select;
  const navigate = useNavigate();
  const [originalSabhaDate, setOriginalSabhaDate] = useState(null);
  const [hasDateChanged, setHasDateChanged] = useState(false);
  const [isBlockedByDuplicate, setIsBlockedByDuplicate] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [villages, setVillages] = useState([]);
  const [showMemberDetails, setShowMemberDetails] = useState(false);
  const userId = sessionStorage.getItem("user_id");
  const role_id = sessionStorage.getItem("role_id");
  const [token, setToken] = useState(sessionStorage.getItem("token") || "");
  const [selectedResourceTypes, setSelectedResourceTypes] = useState([]);
  const [selectedFileNames, setSelectedFileNames] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [isSaveButtonClicked, setIsSaveButtonClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isVoterEditable, setIsVoterEditable] = useState(true);
  const [noticeFileName, setNoticeFileName] = useState("");

  const [formData, setFormData] = useState({
    uploadfile: null,
    meetingNoticeFile: null,
    typeOfGramSabha: "",
    district: "",
    block: "",
    gram_panchayat: "",
    panchayatSecretaryName: "",
    sarpanchMobile: "",
    panchayatAddress: "",
    facilitator: "",
    sabhaDate: null,
    startTime: null,
    sarpanchName: "",
    voterNumber: "",
  });

  const [errors, setErrors] = useState({
    distric: false,
    block: false,
    gram_panchayat: false,
    sabhaDate: false,
    facilitator: false,
    panchayatSecretaryName: false,
    panchayatSecretaryMobile: false,
    sarpanchName: false,
    sarpanchMobile: false,
    panchayatAddress: false,
    panchayatPinCode: false,
    uploadfile: false,
    meetingNoticeFile: false,
    typeOfGramSabha: false,
    startTime: false,
    endTime: false,
    dateRange: false,
    voterNumber: false,
  });

  const handleChange = async (name, value, date) => {
    if (moment.isMoment(value)) {
      value = value.toISOString();
    }

    if (typeof value === "string") {
      if (name === "panchayatSecretaryName") {
        if (value === "") {
          setFormData((prevState) => ({
            ...prevState,
            panchayatSecretaryName: value,
          }));
          setErrors((prev) => ({ ...prev, [name]: false }));
          return;
        }
        // value = value.toUpperCase();

        if (value.charAt(0) === " ") {
          setErrors((prev) => ({
            ...prev,
            [name]: "Presiding Officer Name cannot start with a space.",
          }));
          return;
        }

        setFormData((prevState) => ({
          ...prevState,
          panchayatSecretaryName: value,
        }));

        if (value.length === 0) {
          setErrors((prev) => ({
            ...prev,
            [name]: "Presiding Officer Name cannot be empty or just spaces.",
          }));
        } else {
          setErrors((prev) => ({ ...prev, [name]: false }));
        }
        return;
      }
      if (name === "sarpanchName") {
        if (value === "") {
          setFormData((prevState) => ({
            ...prevState,
            sarpanchName: value,
          }));
          setErrors((prev) => ({ ...prev, [name]: false }));
          return;
        }

        if (value.charAt(0) === " ") {
          setErrors((prev) => ({
            ...prev,
            [name]: "Presiding Officer Designation cannot start with a space.",
          }));
          return;
        }

        setFormData((prevState) => ({
          ...prevState,
          sarpanchName: value,
        }));

        if (value.length === 0) {
          setErrors((prev) => ({
            ...prev,
            [name]:
              "Presiding Officer Designation cannot be empty or just spaces.",
          }));
        } else {
          setErrors((prev) => ({ ...prev, [name]: false }));
        }
        return;
      }

      if (name === "panchayatAddress") {
        if (value === "") {
          setFormData((prevState) => ({
            ...prevState,
            panchayatAddress: value,
          }));
          setErrors((prev) => ({ ...prev, [name]: false }));
          return;
        }

        if (value.charAt(0) === " ") {
          setErrors((prev) => ({
            ...prev,
            [name]: "Venue cannot start with a space.",
          }));
          return;
        }

        setFormData((prevState) => ({
          ...prevState,
          panchayatAddress: value,
        }));

        if (value.length === 0) {
          setErrors((prev) => ({
            ...prev,
            [name]: "Venue cannot be empty or just spaces.",
          }));
        } else {
          setErrors((prev) => ({ ...prev, [name]: false }));
        }
        return;
      }
      if (name === "sarpanchMobile") {
        const isNumber = /^[1-9]\d*$/.test(value);
        if (value && (!isNumber || value.length > 10)) {
          return;
        }
      } else if (name === "file") {
        const file = value[0];
        if (file) {
          setFormData((prevData) => ({
            ...prevData,
            uploadfile: file,
          }));
        }
      }
    }

    if (name === "district") {
      setFormData((prevState) => ({
        ...prevState,
        district: value,
        block: "",
        gram_panchayat: "",
      }));
      setBlocks([]);
      setVillages([]);
      fetchBlocks(value);

      setErrors((prevErrors) => ({
        ...prevErrors,
        district: value ? "" : "District is required",
      }));
    } else if (name === "block") {
      const district_code = formData.district;
      fetchVillages(district_code, value);
      setFormData((prevState) => ({
        ...prevState,
        block: value,
        gram_panchayat: "",
      }));
      setVillages([]);
      setErrors((prevErrors) => ({
        ...prevErrors,
        block: value ? "" : "Block is required",
      }));
    } else if (name === "gram_panchayat") {
      setFormData((prev) => ({
        ...prev,
        gram_panchayat: value,
        voterNumber: "", // reset before fetching
      }));

      setErrors((prev) => ({
        ...prev,
        gram_panchayat: value ? "" : "Gram Panchayat is required",
        voterNumber: "",
      }));

      // ✅ AUTO FETCH VOTER COUNT
      try {
        const res = await getVoterCount(token, {
          district_code: formData.district,
          block_code: formData.block,
          panchayat_code: value,
        });

        if (res?.status === "success") {
          const voterCount = res.voter_count ?? 0;

          setFormData((prev) => ({
            ...prev,
            voterNumber: voterCount.toString(),
          }));

          // ✅ Editable ONLY when voter count is 0
          setIsVoterEditable(voterCount === 0);
        }
      } catch (err) {
        console.error("Voter count fetch failed", err);
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };
  const handleSabhaDateChange = (date) => {
    if (date) {
      // Format date as YYYY-MM-DD without timezone conversion
      const dateString = date.format("YYYY-MM-DD");
      if (originalSabhaDate && dateString !== originalSabhaDate) {
        setHasDateChanged(true);
      }

      setFormData((prev) => ({
        ...prev,
        sabhaDate: dateString,
      }));

      setErrors((prevErrors) => ({
        ...prevErrors,
        sabhaDate: "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        sabhaDate: null,
      }));

      setErrors((prevErrors) => ({
        ...prevErrors,
        sabhaDate: "Gram Sabha Date is required",
      }));
    }
  };

  const handleFinish = async () => {
    setIsSaveButtonClicked(true);
    setLoading(true);
    const formDataToSend = new FormData();
    formDataToSend.append("file", formData.uploadfile);
    formDataToSend.append("district_code", formData.district);
    formDataToSend.append("block_code", formData.block);
    formDataToSend.append("gram_panchayat_code", formData.gram_panchayat);
    formDataToSend.append("sabha_date", formData.sabhaDate);
    formDataToSend.append("start_time", formData.startTime);
    formDataToSend.append(
      "presiding_officer_name",
      formData.panchayatSecretaryName
    );
    formDataToSend.append("presiding_officer_mobile", formData.sarpanchMobile);
    formDataToSend.append("venue", formData.panchayatAddress);
    formDataToSend.append(
      "presiding_officer_designation",
      formData.sarpanchName
    );
    formDataToSend.append("user_id", userId);
    formDataToSend.append("meeting_type", "gram_sabha");
    if (formData.meetingNoticeFile) {
      formDataToSend.append(
        "meeting_notice_upload",
        formData.meetingNoticeFile
      );
    }
    formDataToSend.append("type_of_gram_sabha", formData.typeOfGramSabha || "");

    if (
      Array.isArray(formData.facilitator) &&
      formData.facilitator.length > 0
    ) {
      formData.facilitator.forEach((id) => {
        formDataToSend.append("facilitator[]", id);
      });
    }
    await updateVoterCount(token, {
      district_code: formData.district,
      block_code: formData.block,
      panchayat_code: formData.gram_panchayat,
      gp_voter_count: formData.voterNumber,
    });

    try {
      // Submit the form and check for duplicate meeting error
      const response = await schedule_meeting_api(token, formDataToSend);

      // Check if response contains duplicate meeting error
      if (
        response.status === "error" &&
        response.message &&
        (response.message.includes("already scheduled") ||
          response.message.includes("Meeting already scheduled"))
      ) {
        setOriginalSabhaDate(formData.sabhaDate);
        setIsBlockedByDuplicate(true);
        setHasDateChanged(false);
        setIsSaveButtonClicked(false);
        // Show error message for duplicate meeting
        toast.error(response.message, { autoClose: 3000 });
        setLoading(false);
        return; // Stop further execution
      }
      setOriginalSabhaDate(null);
      setIsBlockedByDuplicate(false);
      setHasDateChanged(false);
      setIsSaveButtonClicked(false);

      // If successful, proceed with success flow
      toast.success("Record Inserted Successfully", { autoClose: 1000 });
      handleReset();
      fetchData();
      setIsSaveButtonClicked(false);
      setLoading(false);
    } catch (error) {
      console.error("Error submitting form:", error);

      // Check if error is about duplicate meeting
      const errorMessage = error.message || error.toString();
      if (
        errorMessage.includes("already scheduled") ||
        errorMessage.includes("Meeting already scheduled")
      ) {
        setOriginalSabhaDate(formData.sabhaDate);
        setIsBlockedByDuplicate(true);
        setHasDateChanged(false);
        toast.error(
          "A meeting is already scheduled for this Panchayat on the selected date!",
          { autoClose: 3000 }
        );
      } else {
        toast.error("Error submitting form", { autoClose: 1000 });
      }

      setLoading(false);
    }
  };

  const fetchDataIfComplete = () => {
    const { district, block, gram_panchayat } = formData;
    if (district && block && gram_panchayat) {
      fetchData();
      getWardSabha(district, block, gram_panchayat);
    }
  };

  const getWardSabha = async (district, block, gram_panchayat) => {
    // const data = {
    //   district_code: district,
    //   block_code: block,
    //   gram_panchayat_code: gram_panchayat,
    //   ward_sabha_check: 2,
    // };
    // try {
    //   const res = await ward_sabha_check(token, data);
    //   if (res.status === "success") {
    //     const count = res.data[0].count;
    //     if (count == 0) {
    //       Swal.fire({
    //         title: 'Please create a ward sabha meeting',
    //         text: 'Do you want to proceed?',
    //         icon: 'warning',
    //         showCancelButton: true,
    //         confirmButtonText: 'Yes, proceed',
    //       }).then((result) => {
    //         if (result.isConfirmed) {
    //           navigate('/ward-sabha-meeting');
    //         } else {
    //           window.location.reload();
    //         }
    //       });
    //     }
    //   } else {
    //     toast.error(res.message, { autoClose: 1000 });
    //   }
    // } catch (error) {
    //   console.error("Error fetching data:", error);
    //   toast.error("An error occurred while fetching data.", { autoClose: 1000 });
    // }
  };

  const handleReset = () => {
    setFormData({
      district: "",
      block: "",
      gram_panchayat: "",
      sabhaDate: "",
      facilitator: "",
      panchayatSecretaryName: "",
      panchayatSecretaryMobile: "",
      sarpanchName: "",
      sarpanchMobile: "",
      panchayatAddress: "",
      panchayatPinCode: "",
      uploadfile: "",
      meetingNoticeFile: null,
      typeOfGramSabha: "",
      dateRange: "",
      startTime: "",
      endTime: "",
      selectedRange: "",
      date: "",
    });
    setErrors({});
    setSelectedFileNames([]);
    setFileList([]);
    setNoticeFileName("");
    setShowMemberDetails(false);
    setOriginalSabhaDate(null);
    setIsBlockedByDuplicate(false);
    setHasDateChanged(false);
    setIsSaveButtonClicked(false);
  };

  const handleSaveAndPreview = async () => {
    setLoading(true);
    const newErrors = {
      sarpanchMobile: validateMobileNo(formData.sarpanchMobile),
      district: formData.district ? "" : "District is required.",
      block: formData.block ? "" : "Block is required.",
      gram_panchayat: formData.gram_panchayat
        ? ""
        : "Gram Panchayat is required.",
      sabhaDate: formData.sabhaDate ? "" : "Sabha Date is required.",
      panchayatSecretaryName: formData.panchayatSecretaryName
        ? ""
        : "Presiding Officer Name is required.",
      sarpanchName: formData.sarpanchName ? "" : "Designation is required.",
      panchayatAddress: formData.panchayatAddress ? "" : "Venue is required.",
      voterNumber: formData.voterNumber ? "" : "Voter count is required",
      uploadfile: selectedFileNames.length > 0 ? "" : "Agenda is required.",
      startTime: formData.startTime ? "" : "Start Time is required.",
      meetingNoticeFile: formData.meetingNoticeFile
        ? ""
        : "Meeting Notice is required.",
      typeOfGramSabha: formData.typeOfGramSabha
        ? ""
        : "Type of Gram Sabha is required.",
    };

    setErrors(newErrors);

    if (Object.values(newErrors).some((err) => err)) {
      setLoading(false);
      return;
    }
    if (isBlockedByDuplicate && !hasDateChanged) {
      toast.error("Please change the date to save a new meeting", { autoClose: 3000 });
      setLoading(false);
      return;
    }
    if (isBlockedByDuplicate && hasDateChanged) {
      setIsBlockedByDuplicate(false);
      setOriginalSabhaDate(null);
      setHasDateChanged(false);
    }
    setIsSaveButtonClicked(true);
    await handleFinish();
  };


  const validateMobileNo = (mobile_no) => {
    if (!mobile_no) return "Mobile Number is required.";
    if (!/^\d{10}$/.test(mobile_no))
      return "Mobile Number must be exactly 10 digits.";
    if (mobile_no[0] === "0") return "Mobile Number cannot start with zero.";
    if (/^0{10}$/.test(mobile_no)) return "Mobile Number cannot be all zeros.";
    return "";
  };

  const fetchDistricts = async () => {
    try {
      const res = await getDistrict(token, userId, role_id);

      if (res.status === "success") {
        setDistricts(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching districts:", error);
      toast.error("An error occurred while fetching districts.", {
        autoClose: 1000,
      });
    }
  };

  const fetchBlocks = async (district_code) => {
    try {
      const res = await getBlockByDistrict(
        token,
        district_code,
        userId,
        role_id
      );

      if (res.status === "success") {
        setBlocks(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching blocks:", error);
      toast.error("An error occurred while fetching blocks.", {
        autoClose: 1000,
      });
    }
  };

  const fetchVillages = async (district_code, block_code) => {
    try {
      const res = await getVillageByBlock(
        token,
        district_code,
        block_code,
        userId,
        role_id
      );

      if (res.status === "success") {
        setVillages(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching villages:", error);
      toast.error("An error occurred while fetching villages.", {
        autoClose: 1000,
      });
    }
  };

  const fetchData = async () => {
    const data = {
      type: "gppft",
      district: parseInt(formData.district, 10),
      block: parseInt(formData.block, 10),
      gram_panchayat: formData.gram_panchayat,
    };
    try {
      const res = await show_resource_detail(token, data);
      if (res.status === "success") {
        setFilteredData(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data.", {
        autoClose: 1000,
      });
    }
  };

  const handleFacilitatorChange = (selectedList) => {
    const selectedIds = selectedList.map((item) => item.id);
    setFormData({ ...formData, facilitator: selectedIds });
    if (selectedIds.length > 0) {
      setErrors((prevErrors) => ({ ...prevErrors, facilitator: null }));
    }
  };
  useEffect(() => {
    if (formData.sabhaDate && originalSabhaDate) {
      if (formData.sabhaDate !== originalSabhaDate) {
        setHasDateChanged(true);
      } else {
        setHasDateChanged(false);
      }
    }
  }, [formData.sabhaDate, originalSabhaDate]);
  useEffect(() => {
    fetchData();
    fetchDataIfComplete();
  }, [
    formData.district,
    formData.block,
    formData.gram_panchayat,
    selectedResourceTypes,
  ]);

  useEffect(() => {
    fetchData();
    fetchDistricts();
    handleReset();
  }, []);

  return (
    <>
      <div id="loading-coupon" style={{ display: loading ? "flex" : "none" }}>
        <img id="loading-image" src={loader} alt="Loading..." />
      </div>

      <div
        className="container-fluid"
        style={{ top: "0", left: "100", margin: "16px" }}
      >
        <div>
          <div>
            <h2
              className="pt-10"
              style={{
                top: "0",
                left: "0",
                margin: "16px",
                marginTop: "-5px",
                fontWeight: "bold",
              }}
            >
              Gram Sabha Scheduled meeting
            </h2>
          </div>
          <Form
            className="mt-4"
            layout="vertical"
            onFinish={handleFinish}
            style={{
              fontWeight: "bold",
              marginLeft: "1.5%",
              marginRight: "1.5%",
              background: "#FFFFFF",
              padding: "30px",
              borderRadius: "15px",
              boxShadow: "0 6px 12px rgba(0, 0, 0, .4)",
            }}
          >
            <Row gutter={16} className="">
              <Col span={8}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: "600", fontSize: "16px" }}>
                      {" "}
                      District Name{" "}
                      <span
                        style={{
                          color:
                            formData.district && !errors.district
                              ? "black"
                              : "#FF506B",
                        }}
                      >
                        *
                      </span>{" "}
                    </span>
                  }
                  help={errors.district ? "District is required" : ""}
                  validateStatus={
                    errors.district
                      ? "error"
                      : formData.district
                        ? "success"
                        : ""
                  }
                >
                  <Select
                    id="district"
                    value={formData.district || undefined}
                    onChange={(value) => handleChange("district", value)}
                    placeholder={
                      <span
                        style={{
                          fontWeight: "400",
                          color: "gray",
                          fontSize: "16px",
                          height: "40px",
                        }}
                      >
                        {" "}
                        Select District Name{" "}
                      </span>
                    }
                    className={`custom-input ${errors.district
                      ? "is-invalid"
                      : formData.district
                        ? "is-valid"
                        : ""
                      }`}
                    style={{ height: "40px", width: "100%" }}
                  >
                    {districts?.map((district, index) => (
                      <Option key={index} value={district.district_code}>
                        {district.district}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: "600", fontSize: "16px" }}>
                      Block Name{" "}
                      <span
                        style={{
                          color:
                            formData.block && !errors.block
                              ? "black"
                              : "#FF506B",
                        }}
                      >
                        *
                      </span>{" "}
                    </span>
                  }
                  help={errors.block ? "Block is required" : ""}
                  validateStatus={
                    errors.block ? "error" : formData.block ? "success" : ""
                  }
                >
                  <Select
                    id="block"
                    value={formData.block || undefined}
                    onChange={(value) => handleChange("block", value)}
                    placeholder={
                      <span
                        style={{
                          fontWeight: "400",
                          color: "gray",
                          fontSize: "16px",
                          height: "40px",
                        }}
                      >
                        {" "}
                        Select Block Name{" "}
                      </span>
                    }
                    className={`${errors.block
                      ? "is-invalid"
                      : formData.block
                        ? "is-valid"
                        : ""
                      }`}
                    style={{ height: "40px", width: "100%" }}
                  >
                    {blocks?.map((block, index) => (
                      <Option key={index} value={block.block_code}>
                        {block.block}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: "600", fontSize: "16px" }}>
                      Gram Panchayat Name{" "}
                      <span
                        style={{
                          color:
                            formData.gram_panchayat && !errors.gram_panchayat
                              ? "black"
                              : "red",
                        }}
                      >
                        *
                      </span>{" "}
                    </span>
                  }
                  help={
                    errors.gram_panchayat ? "Gram Panchayat is required" : ""
                  }
                  validateStatus={
                    errors.gram_panchayat
                      ? "error"
                      : formData.gram_panchayat
                        ? "success"
                        : ""
                  }
                >
                  <Select
                    id="gram_panchayat"
                    value={formData.gram_panchayat || undefined}
                    onChange={(value) => handleChange("gram_panchayat", value)}
                    placeholder={
                      <span
                        style={{
                          fontWeight: "400",
                          color: "gray",
                          fontSize: "16px",
                          height: "40px",
                        }}
                      >
                        Select Gram Panchayat Name{" "}
                      </span>
                    }
                    className={`${errors.gram_panchayat
                      ? "is-invalid"
                      : formData.gram_panchayat
                        ? "is-valid"
                        : ""
                      }`}
                    style={{ height: "40px", width: "100%" }}
                  >
                    {villages?.map((village, index) => (
                      <Option key={index} value={village.gram_panchayat_code}>
                        {village.gram_panchayat}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>

              <Col span={8}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: "600", fontSize: "16px" }}>
                      Gram Sabha Date{" "}
                      <span
                        style={{
                          color:
                            formData.sabhaDate && !errors.sabhaDate ? "black" : "red",
                        }}
                      >
                        *
                      </span>{" "}
                    </span>
                  }
                  help={errors.sabhaDate ? " Gram Sabha Date is required" : ""}
                  className={errors.sabhaDate ? "is-invalid" : ""}
                  validateStatus={errors.sabhaDate ? "error" : ""}
                >
                  <CustomDatePicker
                    value={
                      formData.sabhaDate
                        ? moment(formData.sabhaDate, "YYYY-MM-DD")
                        : null
                    }
                    onChange={(date) => {
                      if (date) {
                        const dateString = date.format("YYYY-MM-DD");

                        if (originalSabhaDate && dateString !== originalSabhaDate) {
                          setHasDateChanged(true);
                        }

                        setFormData((prev) => ({
                          ...prev,
                          sabhaDate: dateString,
                        }));

                        setErrors((prev) => ({
                          ...prev,
                          sabhaDate: "",
                        }));
                      } else {
                        setFormData((prev) => ({
                          ...prev,
                          sabhaDate: null,
                        }));

                        setErrors((prev) => ({
                          ...prev,
                          sabhaDate: "Gram Sabha Date is required",
                        }));
                      }
                    }}
                    disabledDate={(current) =>
                      current && current < moment().startOf("day")
                    }
                    format="YYYY-MM-DD"
                    status={errors.sabhaDate ? "error" : ""}
                    placeholder="Select date"
                  />

                  {isBlockedByDuplicate && !hasDateChanged && (
                    <div
                      style={{
                        color: "#FF506B",
                        fontSize: "12px",
                        marginTop: "4px",
                      }}
                    >
                      A meeting already exists on this date. Please change the
                      date to save again.
                    </div>
                  )}
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: "600", fontSize: "16px" }}>
                      {" "}
                      Gram Sabha Meeting Time{" "}
                      <span
                        style={{
                          color:
                            formData.startTime && !errors.startTime
                              ? "black"
                              : "red",
                        }}
                      >
                        *
                      </span>{" "}
                    </span>
                  }
                  help={
                    errors.startTime
                      ? " Gram Sabha Meeting Time is required"
                      : ""
                  }
                  validateStatus={errors.startTime ? "error" : ""}
                >
                  <TimePicker
                    value={
                      formData.startTime
                        ? moment(formData.startTime, "HH:mm")
                        : null
                    }
                    onChange={(time) => {
                      if (time) {
                        const selectedTime = time.format("HH:mm");
                        const currentTime = moment().format("HH:mm");

                        if (
                          moment(formData.sabhaDate).isSame(moment(), "day") &&
                          moment(selectedTime, "HH:mm").isBefore(
                            moment(currentTime, "HH:mm")
                          )
                        ) {
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            startTime:
                              "Meeting time cannot be in the past for today",
                          }));
                        } else {
                          handleChange("startTime", selectedTime);
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            startTime: "",
                          }));
                        }
                      } else {
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          startTime: " Gram Sabha Meeting Time is required",
                        }));
                      }
                    }}
                    style={{ width: "100%", height: "40px" }}
                    className={`dark-placeholder form-control ${errors.startTime ? "is-invalid" : ""
                      }`}
                    format={"HH:mm"}
                    showNow={true}
                    disabledHours={() => {
                      if (moment(formData.sabhaDate).isSame(moment(), "day")) {
                        const currentHour = moment().hour();
                        const hours = [];
                        for (let i = 0; i < currentHour; i++) {
                          hours.push(i);
                        }
                        return hours;
                      }
                      return [];
                    }}
                    disabledMinutes={(selectedHour) => {
                      if (
                        moment(formData.sabhaDate).isSame(moment(), "day") &&
                        selectedHour === moment().hour()
                      ) {
                        const currentMinute = moment().minute();
                        const minutes = [];
                        for (let i = 0; i <= currentMinute; i++) {
                          minutes.push(i);
                        }
                        return minutes;
                      }
                      return [];
                    }}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: "600", fontSize: "16px" }}>
                      {" "}
                      Presiding Officer Name{" "}
                      <span
                        style={{
                          color:
                            formData.panchayatSecretaryName &&
                              !errors.panchayatSecretaryName
                              ? "black"
                              : "#FF506B",
                        }}
                      >
                        *
                      </span>{" "}
                    </span>
                  }
                  help={
                    errors.panchayatSecretaryName
                      ? "Presiding Officer Name is required"
                      : ""
                  }
                  validateStatus={
                    errors.panchayatSecretaryName
                      ? "error"
                      : formData.panchayatSecretaryName
                        ? "success"
                        : ""
                  }
                >
                  <Input
                    id="panchayatSecretaryName"
                    className="dark-placeholder form-control"
                    value={formData.panchayatSecretaryName}
                    onChange={(e) =>
                      handleChange(
                        "panchayatSecretaryName",
                        e.target.value.replace(/[^a-zA-Z\s]/g, "")
                      )
                    }
                    placeholder="Enter Presiding Officer Name"
                    style={{
                      fontWeight: "400",
                      color: "gray",
                      fontSize: "16px",
                      height: "40px",
                    }}
                    placeholderstyle={{ fontWeight: "600" }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: "600", fontSize: "16px" }}>
                      Presiding Officer Designation
                      <span
                        style={{
                          color:
                            formData.sarpanchName && !errors.sarpanchName
                              ? "black"
                              : "#FF506B",
                        }}
                      >
                        *
                      </span>
                    </span>
                  }
                  help={
                    errors.sarpanchName
                      ? "Presiding Officer Designation is required"
                      : ""
                  }
                  validateStatus={
                    errors.sarpanchName
                      ? "error"
                      : formData.sarpanchName
                        ? "success"
                        : ""
                  }
                >
                  <Input
                    className="dark-placeholder form-control"
                    value={formData.sarpanchName}
                    onChange={(e) =>
                      handleChange("sarpanchName", e.target.value)
                    }
                    placeholder="Enter Presiding Officer Designation"
                    style={{ height: "40px" }}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: "600", fontSize: "16px" }}>
                      Presiding Officer Mobile No.{" "}
                      <span
                        style={{
                          color:
                            formData.sarpanchMobile && !errors.sarpanchMobile
                              ? "black"
                              : "#FF506B",
                        }}
                      >
                        *
                      </span>{" "}
                    </span>
                  }
                  help={
                    errors.sarpanchMobile
                      ? "Presiding Officer Mobile No. is required and must be a valid number"
                      : ""
                  }
                  validateStatus={
                    errors.sarpanchMobile
                      ? "error"
                      : formData.sarpanchMobile
                        ? "success"
                        : ""
                  }
                >
                  <Input
                    className="dark-placeholder form-control"
                    value={formData.sarpanchMobile}
                    onChange={(e) =>
                      handleChange("sarpanchMobile", e.target.value)
                    }
                    placeholder="Enter Presiding Officer Mobile No."
                    style={{ height: "40px" }}
                  />
                </Form.Item>
              </Col>

              {/* ✅ Type of Gram Sabha placed here (earlier facilitator position) */}
              <Col span={8}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: "600", fontSize: "16px" }}>
                      Type of Gram Sabha{" "}
                      <span
                        style={{
                          color:
                            formData.typeOfGramSabha && !errors.typeOfGramSabha
                              ? "black"
                              : "#FF506B",
                        }}
                      >
                        *
                      </span>
                    </span>
                  }
                  help={
                    errors.typeOfGramSabha
                      ? "Type of Gram Sabha is required"
                      : ""
                  }
                  validateStatus={
                    errors.typeOfGramSabha
                      ? "error"
                      : formData.typeOfGramSabha
                        ? "success"
                        : ""
                  }
                >
                  <Select
                    value={formData.typeOfGramSabha || undefined}
                    onChange={(value) => {
                      setFormData((prev) => ({
                        ...prev,
                        typeOfGramSabha: value,
                      }));
                      setErrors((prev) => ({ ...prev, typeOfGramSabha: "" }));
                    }}
                    placeholder={
                      <span
                        style={{
                          fontWeight: "400",
                          color: "gray",
                          fontSize: "16px",
                          height: "40px",
                        }}
                      >
                        Type of Gram Sabha
                      </span>
                    }
                    style={{ height: "40px", width: "100%" }}
                    className={`${errors.typeOfGramSabha
                      ? "is-invalid"
                      : formData.typeOfGramSabha
                        ? "is-valid"
                        : ""
                      }`}
                  >
                    <Option value="Special">Special</Option>
                    <Option value="Regular">Regular</Option>
                  </Select>
                </Form.Item>
              </Col>

              {/* OLD FACILITATOR BLOCK REMAINS COMMENTED OUT */}
              {/* <div className="col-md-4">
                ...
              </div> */}
            </Row>

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: "600", fontSize: "16px" }}>
                      Venue{" "}
                      <span
                        style={{
                          color:
                            formData.panchayatAddress &&
                              !errors.panchayatAddress
                              ? "black"
                              : "#FF506B",
                        }}
                      >
                        *
                      </span>
                    </span>
                  }
                  help={
                    errors.panchayatAddress
                      ? "Venue is required and cannot start with a space"
                      : ""
                  }
                  validateStatus={
                    errors.panchayatAddress
                      ? "error"
                      : formData.panchayatAddress
                        ? "success"
                        : ""
                  }
                >
                  <Input
                    className="dark-placeholder form-control"
                    value={formData.panchayatAddress}
                    onChange={(e) =>
                      handleChange("panchayatAddress", e.target.value)
                    }
                    placeholder="Enter Panchayat Address"
                    style={{ height: "40px" }}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: "600", fontSize: "16px" }}>
                      Number of Voters{" "}
                      <span
                        style={{
                          color: formData.voterNumber ? "black" : "#FF506B",
                        }}
                      >
                        *
                      </span>
                    </span>
                  }
                  help={errors.voterNumber ? "Voter count is required" : ""}
                  validateStatus={
                    errors.voterNumber
                      ? "error"
                      : formData.voterNumber
                        ? "success"
                        : ""
                  }
                >
                  <Input
                    value={formData.voterNumber}
                    disabled={!isVoterEditable}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      setFormData((prev) => ({ ...prev, voterNumber: value }));
                      setErrors((prev) => ({
                        ...prev,
                        voterNumber: value ? "" : "Required",
                      }));
                    }}
                    placeholder="Total voters in this Gram Panchayat"
                    style={{ height: "40px" }}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <div className="form-group">
                  <label
                    className="mt-1"
                    style={{
                      fontWeight: "600",
                      fontSize: "16px",
                      color: "black",
                      marginBottom: "8px",
                    }}
                  >
                    Upload Agenda{" "}
                    <span
                      style={{
                        color:
                          formData.uploadfile && !errors.uploadfile
                            ? "black"
                            : "#FF506B",
                      }}
                    >
                      *
                    </span>
                  </label>

                  <input
                    type="file"
                    accept=".pdf,.docx"
                    multiple
                    onChange={(e) => {
                      const files = Array.from(e.target.files);
                      const isValid = files.every(
                        (file) =>
                          file.type === "application/pdf" ||
                          file.type ===
                          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      );

                      if (!isValid) {
                        setErrors((prev) => ({
                          ...prev,
                          uploadfile: "Only PDF and DOCX files are allowed.",
                          fileEmpty: "",
                        }));
                      } else if (files.length) {
                        const fileNames = files.map((file) => file.name);
                        setSelectedFileNames(fileNames);
                        setFileList(files);
                        handleChange("file", files);
                        setFormData((prevData) => ({
                          ...prevData,
                          uploadfile: files[0],
                        }));
                        setErrors((prev) => ({
                          ...prev,
                          uploadfile: "",
                          fileEmpty: "",
                        }));
                      } else {
                        setErrors((prev) => ({
                          ...prev,
                          fileEmpty: "Agenda is required",
                        }));
                      }
                    }}
                    style={{ display: "none" }}
                    id="fileUpload"
                  />

                  <label
                    htmlFor="fileUpload"
                    className="btn w-100"
                    style={{
                      height: "40px",
                      border:
                        errors.uploadfile || errors.fileEmpty
                          ? "1px solid #FF506B"
                          : "1px solid #DEE2E6",
                      color: "black",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    Upload File
                  </label>

                  {errors.uploadfile && (
                    <div style={{ color: "#FF506B", marginTop: "4px" }}>
                      {errors.uploadfile}
                    </div>
                  )}

                  {selectedFileNames.length > 0 && (
                    <div>
                      <ul
                        style={{
                          display: "flex",
                          listStyleType: "none",
                          padding: 0,
                          margin: 0,
                        }}
                      >
                        {selectedFileNames.map((name, index) => (
                          <Tooltip key={index} title={name} placement="top">
                            <li className="file-name-ellipsis">
                              {name}
                            </li>
                          </Tooltip>
                        ))}
                      </ul>

                    </div>
                  )}

                  {!selectedFileNames.length && errors.fileEmpty && (
                    <div style={{ color: "#FF506B", marginTop: "4px" }}>
                      Agenda is required
                    </div>
                  )}
                </div>
              </Col>
              <Col span={8}>
                <div className="form-group">
                  <label
                    className="mt-1"
                    style={{
                      fontWeight: "600",
                      fontSize: "16px",
                      color: "black",
                      marginBottom: "8px",
                    }}
                  >
                    Meeting Notice Upload{" "}
                    <span
                      style={{
                        color:
                          formData.meetingNoticeFile &&
                            !errors.meetingNoticeFile
                            ? "black"
                            : "#FF506B",
                      }}
                    >
                      *
                    </span>
                  </label>

                  <input
                    type="file"
                    accept=".pdf,.docx"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (!file) {
                        setErrors((prev) => ({
                          ...prev,
                          meetingNoticeFile: "Meeting Notice is required.",
                        }));
                        setNoticeFileName("");
                        setFormData((prev) => ({
                          ...prev,
                          meetingNoticeFile: null,
                        }));
                        return;
                      }

                      const isValid =
                        file.type === "application/pdf" ||
                        file.type ===
                        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

                      if (!isValid) {
                        setErrors((prev) => ({
                          ...prev,
                          meetingNoticeFile:
                            "Only PDF and DOCX files are allowed for Meeting Notice.",
                        }));
                        setNoticeFileName("");
                        setFormData((prev) => ({
                          ...prev,
                          meetingNoticeFile: null,
                        }));
                      } else {
                        setFormData((prev) => ({
                          ...prev,
                          meetingNoticeFile: file,
                        }));
                        setNoticeFileName(file.name);
                        setErrors((prev) => ({
                          ...prev,
                          meetingNoticeFile: "",
                        }));
                      }
                    }}
                    style={{ display: "none" }}
                    id="meetingNoticeUpload"
                  />

                  <label
                    htmlFor="meetingNoticeUpload"
                    className="btn w-100"
                    style={{
                      height: "40px",
                      border: errors.meetingNoticeFile
                        ? "1px solid #FF506B"
                        : "1px solid #DEE2E6",
                      color: "black",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    Upload Meeting Notice
                  </label>

                  {errors.meetingNoticeFile && (
                    <div style={{ color: "#FF506B", marginTop: "4px" }}>
                      {errors.meetingNoticeFile}
                    </div>
                  )}

                  {noticeFileName && (
                    <div style={{ marginTop: "4px" }}>
                      <ul
                        style={{ listStyleType: "none", padding: 0, margin: 0 }}
                      >
                        <li>{noticeFileName}</li>
                      </ul>
                    </div>
                  )}
                </div>
              </Col>
            </Row>

            <div
              className="row"
              style={{
                marginTop: "20px",
                marginLeft: "1.5%",
                marginRight: "1.5%",
              }}
            >
              <div className="col text-end">
                <Button
                  type="default"
                  style={{
                    backgroundColor: "#DCE2FA",
                    color: "#4763E4",
                    marginRight: "10px",
                    width: "10%",
                    transition: "background-color 0.3s, color 0.3s",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#4763E4";
                    e.target.style.color = "#DCE2FA";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#DCE2FA";
                    e.target.style.color = "#4763E4";
                  }}
                  onClick={handleReset}
                >
                  Cancel
                </Button>
                <Button
                  type="primary"
                  style={{
                    backgroundColor:
                      isBlockedByDuplicate && !hasDateChanged
                        ? "#f0f0f0"
                        : "#DCE2FA",
                    color:
                      isBlockedByDuplicate && !hasDateChanged
                        ? "#999"
                        : "#4763E4",
                    marginRight: "10px",
                    width: "10%",
                    transition: "background-color 0.3s, color 0.3s",
                    cursor:
                      (isBlockedByDuplicate && !hasDateChanged) ||
                        isSaveButtonClicked
                        ? "not-allowed"
                        : "pointer",
                  }}
                  onMouseEnter={(e) => {
                    if (
                      !(isBlockedByDuplicate && !hasDateChanged) &&
                      !isSaveButtonClicked
                    ) {
                      e.target.style.backgroundColor = "#4763E4";
                      e.target.style.color = "#DCE2FA";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (
                      !(isBlockedByDuplicate && !hasDateChanged) &&
                      !isSaveButtonClicked
                    ) {
                      e.target.style.backgroundColor = "#DCE2FA";
                      e.target.style.color = "#4763E4";
                    } else if (isBlockedByDuplicate && !hasDateChanged) {
                      e.target.style.backgroundColor = "#f0f0f0";
                      e.target.style.color = "#999";
                    }
                  }}
                  disabled={
                    (isBlockedByDuplicate && !hasDateChanged) ||
                    isSaveButtonClicked
                  }
                  onClick={handleSaveAndPreview}
                >
                  Save
                </Button>
              </div>
            </div>
          </Form>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};
export default GramSabhaMeeting;